<template>
  <div>
    <div v-if="!specieId">
      <v-btn @click="dialogOpen = true" :disabled="!genusId" class="orange">{{ $t("select") }}</v-btn>
    </div>
    <div v-else>
      <v-chip class="ma-2" :close="!readOnly" color="#F5F5F5" @click:close="selectHandler(null)">{{ specieName() }}</v-chip>
    </div>

    <custom-dialog
      v-if="dialogOpen"
      @close="dialogOpen = false"
      :title="$t('select_flower_specie')"
      hide-actions
    >
      <template v-slot:text>
        <v-list style="max-height: 50vh; overflow: auto" :key="updated">
          <div v-for="(array, key) in specieGroups()" :key="key">
            <div class="specieGroupKana">{{ key }}</div>
            <div v-for="specie in array" :key="specie.id">
              <v-list-item @click="selectHandler(specie.id)">
                <v-list-item-avatar v-if="specie.image_url">
                  <v-img :src="specie.image_url" />
                </v-list-item-avatar>
                <v-list-item-content>{{ specie.name }}</v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </div>
        </v-list>

        <Form :genus-id="genusId" :edit="editId" @finish="onAdded" class="pt-6"/>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/shared/CustomDialog.vue";
import Form from "@/components/farm/flowers/specie/Form.vue";

export default {
  components: { CustomDialog, Form },
  props: {
    specieId: {
      type: Number,
      default: null
    },
    genusId: {
      type: Number,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      dialogOpen: false,
      optionsCount: 0,
      name: null,
      editId: null,
      updated: 0
    };
  },
  methods: {
    selectHandler(id) {
      this.dialogOpen = false;
      this.$emit("select", id);
    },
    editHandler(id) {
      this.editId = id;
    },
    async deleteHandler(id) {
      if (this.genusId) {
        await this.$store.dispatch("flowerSpecie/delFlowerSpecie", {
          genusId: this.genusId,
          specieId: id
        });
        this.updated++;
      }
    },
    onAdded(id) {
      this.$emit("select", id);
      this.dialogOpen = false;
    },
    specieGroups() {
      const options = this.$store.state.flowerSpecie.options[this.genusId];
      if (!options) return [];

      this.optionsCount = options.length - 1;

      const specieGroups = {};
      options.forEach(specie => {
        const specieName = specie.name_furigana;

        const firstChar = this.$sortKana.reverse[specieName.charAt(0)];

        if (!specieGroups[firstChar]) specieGroups[firstChar] = [];

        if (!specieGroups[firstChar].includes(specie)) {
          specieGroups[firstChar].push(specie);
        }
      });

      const keys = Object.keys(specieGroups);
      keys.sort((a, b) => a.localeCompare(b));

      const sortedSpecieGroups = {};
      keys.forEach(x => {
        specieGroups[x].sort((a, b) => a.name_furigana.localeCompare(b.name_furigana));
        sortedSpecieGroups[x] = specieGroups[x];
      });

      return sortedSpecieGroups;
    },
    getSpecie(name_furigana) {
      return this.options[this.genusId].find(specie => specie.name_furigana === name_furigana);
    },
    specieKeys() {
      return Object.keys(this.specieGroups);
    },
    specieName() {
      return this.$store.getters["flowerSpecie/name"](this.specieId);
    }
  },
  computed: {

  }
};
</script>

<style scoped>
.specieGroupKana {
  background-color: rgb(240, 240, 240);
  padding: 5px;
}
</style>
